module.exports = __webpack_public_path__ + "img/MoonPay2.c48f0d38.png";